import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Settings from 'core/settings';
const containerCss = "c13rz8op";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const MaxWorkflowBanner = () => <Banner type="warning">
    <Container>
      <BodyText>
        <BodyText weight="bold" inline>
          {I18n.t('publisher.workflows.max_workflow_exceeded.line1', {
          limit: Settings.max_workflow_limit
        })}
        </BodyText>
        {' '}
        {I18n.t('publisher.workflows.max_workflow_exceeded.line2')}
      </BodyText>
    </Container>
  </Banner>;

require("./max_workflow_banner.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./max_workflow_banner.js");